export default __webpack_public_path__ + "static/media/check-message.e9ecc7bf.svg";